import * as Models from '../Models';
import * as PartnerApiClient from './PartnerApiClientService';
import * as PartnerSettingsApiClientService from './PartnerSettingsApiClientService';

export interface IPartnerRetrievalService {
  getPartners(excludeUsersGroups?: boolean): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
  getPartner(partnerCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel>;
  getPartnerSettings(partnerCode: string): ng.IPromise<Models.PartnerSettingsModel.IPartnerSettings>;
  getPartnerRelationships(stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
  getPartnerRelationshipsByPartner(partnerCode: string, stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
  getPartnersForUserManagement(): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
}

export class PartnerRetrievalService implements IPartnerRetrievalService {
  public static $inject = [
    'PartnerApiClientService',
    'PartnerSettingsApiClientService'
  ];

  constructor(
    private partnerApiClientService: PartnerApiClient.IPartnerApiClientService,
    private partnerSettingsApiClientService: PartnerSettingsApiClientService.IPartnerSettingsApiClientService
  ) {}

  public getPartners = (excludeUsersGroups?: boolean) => {
    return this.partnerApiClientService.getPartners(excludeUsersGroups || false);
  }

  public getPartner = (partnerCode: string) => {
    return this.partnerApiClientService.getPartnerByCode(partnerCode);
  }

  public getPartnerSettings = (partnerCode: string) => {
    return this.partnerSettingsApiClientService.getPartnerSettings(partnerCode);
  }

  public getPartnerRelationships = (stateCode: string) => {
    return this.partnerSettingsApiClientService.getPartnerRelationships(stateCode);
  }

  public getPartnerRelationshipsByPartner = (partnerCode: string, stateCode: string) => {
    return this.partnerSettingsApiClientService.getPartnerRelationshipsByPartner(partnerCode, stateCode);
  }

  public getPartnersForUserManagement = () => {
    return this.partnerSettingsApiClientService.getPartnersForUserManagement();
  }
}
